export default __webpack_public_path__ + "static/media/WINE8.77b40d7c.jpg";